(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const prepare = () => {
    const menu = document.getElementById('offcanvas-menu');
    if (menu && !menu.dataset.soaMotionReady) {
      menu.dataset.soaMotionReady = 'true';
      let timer;
      menu.addEventListener('show.bs.offcanvas', () => {
        if (motion.matches) return;
        menu.classList.add('soa-paper-opening');
        clearTimeout(timer);
        timer = setTimeout(() => menu.classList.remove('soa-paper-opening'), 650);
      });
      menu.addEventListener('hidden.bs.offcanvas', () => {
        clearTimeout(timer);
        menu.classList.remove('soa-paper-opening');
      });
    }
    if (!('IntersectionObserver' in window)) return;
    const icons = {
      autumn: '<svg viewBox="0 0 40 44"><path d="M20 2l4 10 8-5-2 12 9 1-9 8 2 8-11-3-9 5 1-10-11-6 10-3-2-10 9 5Z" fill="currentColor"/><path d="M20 12v30M20 25l-8-6m8 10 9-8" stroke="#87552e" stroke-width="1.2" fill="none"/></svg>',
      pumpkin: '<svg viewBox="0 0 40 40" fill="none"><path d="M21 10c-1-5 2-7 5-7" stroke="#b49b63" stroke-width="2.5" stroke-linecap="round"/><path d="M20 12C3 5 0 30 12 34c4 2 6 0 8 0s5 2 9 0c12-4 8-29-9-22Z" fill="currentColor" fill-opacity=".5" stroke="currentColor" stroke-width="1.5"/><ellipse cx="20" cy="23" rx="7" ry="12" stroke="currentColor" stroke-width="1.3"/></svg>',
      snow: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M20 3v34M5 11l30 18M5 29l30-18M15 7l5 5 5-5M15 33l5-5 5 5M6 17l7-2-1-7M28 32l-1-7 7-2M6 23l7 2-1 7M28 8l-1 7 7 2"/></svg>',
      sakura: '<svg viewBox="0 0 32 40"><path d="M16 36C-3 25 1 6 10 3l6 5 6-5c11 5 12 20-6 33Z" fill="currentColor" fill-opacity=".65"/><path d="M16 11v20" stroke="currentColor" stroke-width="1"/></svg>'
    };
    const lineIcon = body => '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + body + '</svg>';
    Object.assign(icons, {
      magic: lineIcon('<path d="m20 3 4 12 13 5-13 4-4 13-5-13-12-4 12-5Z" fill="currentColor" fill-opacity=".25"/><path d="m32 3 1 4 4 1-4 1-1 4-1-4-4-1 4-1Z"/>'),
      music: lineIcon('<path d="M14 29V10l18-5v20M14 15l18-5"/><ellipse cx="9" cy="30" rx="5" ry="4" fill="currentColor"/><ellipse cx="27" cy="26" rx="5" ry="4" fill="currentColor"/>'),
      travel: lineIcon('<path d="m4 16 12 1L27 5l5-1-6 14 9 3-1 4-11-1-5 11-4 1 2-13-10-3Z" fill="currentColor" fill-opacity=".25"/>'),
      leaf: lineIcon('<path d="M7 33C-1 12 18 5 34 5c0 19-8 32-27 28Z" fill="currentColor" fill-opacity=".25"/><path d="M5 37 28 12M14 28l-2-10m8 4 10-2"/>'),
      heart: lineIcon('<path d="M20 34 6 20C-4 8 12-1 20 10 28-1 44 8 34 20Z" fill="currentColor" fill-opacity=".28"/>'),
      paw: lineIcon('<ellipse cx="10" cy="13" rx="4" ry="6"/><ellipse cx="20" cy="8" rx="4" ry="6"/><ellipse cx="30" cy="13" rx="4" ry="6"/><path d="M20 19c-6 0-6 7-10 9-5 5 1 11 6 7 3-2 5-2 8 0 5 4 11-2 6-7-4-2-4-9-10-9Z" fill="currentColor" fill-opacity=".25"/>'),
      ocean: lineIcon('<path d="M3 14c6-9 11 9 17 0s11 9 17 0M3 24c6-9 11 9 17 0s11 9 17 0M3 34c6-9 11 9 17 0s11 9 17 0"/>'),
      space: lineIcon('<circle cx="20" cy="20" r="10" fill="currentColor" fill-opacity=".25"/><ellipse cx="20" cy="20" rx="20" ry="5" transform="rotate(-30 20 20)"/><path d="M31 4v6m-3-3h6"/>'),
      sport: lineIcon('<circle cx="20" cy="20" r="16"/><path d="m20 12 8 6-3 9H15l-3-9ZM20 4v8M5 15l7 3m3 9-5 6m15-6 5 6m-2-15 7-3"/>'),
      coffee: lineIcon('<path d="M6 16h23v10a11 11 0 0 1-23 0ZM29 18h4a5 5 0 0 1 0 10h-5M4 38h29M12 4c-5 5 5 5 0 10m8-10c-5 5 5 5 0 10"/>'),
      mushroom: lineIcon('<path d="M3 23C3 0 37 0 37 23ZM16 23l-2 14h12l-2-14" fill="currentColor" fill-opacity=".25"/><circle cx="14" cy="15" r="2"/><circle cx="25" cy="12" r="2"/>')
    });
    const productKind = value => {
      const name = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const themes = [
        [/noel|christmas|neige|enneige|snowboard|sapin/, 'snow'],
        [/halloween|citrouille/, 'pumpkin'],
        [/sakura|cerisier/, 'sakura'],
        [/sorcier|sorcellerie|magicien|magique|boule-ailee/, 'magic'],
        [/piano|violon|gramophone|lyre|musique/, 'music'],
        [/champignon/, 'mushroom'],
        [/automne|saisonnier|arbre-sacre/, 'autumn'],
        [/amour|amants|coeur|tendresse|romantique|promesse|meres|roses/, 'heart'],
        [/spatial|astronaute|cosmique|futur|mecha|cyberpunk/, 'space'],
        [/football|ballon|basketball|arts-martiaux/, 'sport'],
        [/chien|corgi|niche|chat-|panda|faon|tyrannosaure|triceratops|bouledogue/, 'paw'],
        [/marin|navire|titanic|croisiere|pirate|loutre/, 'ocean'],
        [/barista/, 'coffee'],
        [/arbre|chene|fleur|foret|bois|montagne|tournesol|lotus|libellule|orange|shenmu/, 'leaf'],
        [/paris|louvre|eiffel|york|santorin|sydney|colisee|khalifa|tokyo|temple|pagode|potala|paix|autel|terre-cuite|train|suv/, 'travel']
      ];
      return themes.find(([pattern]) => pattern.test(name))?.[1] || 'magic';
    };
    const product = document.querySelector('#product-template');
    const kind = productKind(location.pathname + ' ' + (product?.querySelector('h1')?.textContent || ''));
    const targets = [['#soa-halloween','pumpkin'],['#soa-noel','snow'],['.soa-home-hero','autumn'],['.soa-home-favorites','autumn'],['.soa-home-demo','sakura'],['.soa-home-selections','sakura'],['.soa-keepsakes-v6','sakura']];
    if (product && !/protection-de-colis|carte-cadeau/.test(location.pathname)) {
      targets.push(['#product-template .main-splide', kind], ['.soa-story-image', kind]);
    }
    const hosts = new Set();
    const visible = new Set();
    const update = () => hosts.forEach(host => host.classList.toggle('soa-season-active', visible.has(host) && !motion.matches && !document.hidden && !navigator.connection?.saveData));
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      update();
    }, { threshold: 0 });
    targets.forEach(([selector,kind]) => {
      document.querySelectorAll(selector).forEach(host => {
        if (host.dataset.soaSeasonReady) return;
        host.dataset.soaSeasonReady = 'true';
        host.classList.add('soa-season-host');
        const isProduct = host.matches('#product-template .main-splide, .soa-story-image');
        if (isProduct) host.classList.add('soa-season-product');
        host.dataset.soaSeasonKind = kind;
        const layer = document.createElement('div');
        layer.className = 'soa-season-particles soa-season-' + kind;
        layer.setAttribute('aria-hidden','true');
        for (let i=0; i<(isProduct ? 4 : 6); i++) {
          const item = document.createElement('span');
          item.innerHTML = icons[kind];
          item.style.setProperty('--particle-left', (8 + Math.random() * 80) + '%');
          item.style.setProperty('--particle-size', (kind === 'pumpkin' ? 28 : 20) + (i % 4) * 5 + 'px');
          item.style.setProperty('--particle-delay', (-i * 1.73) + 's');
          item.style.setProperty('--particle-duration', (12 + Math.random() * 8) + 's');
          item.style.setProperty('--particle-top', (12 + Math.random() * 65) + '%');
          item.style.setProperty('--particle-x', (Math.random() * 80 - 40) + 'px');
          item.style.setProperty('--particle-y', (Math.random() * 100 - 50) + 'px');
          item.style.setProperty('--particle-turn', (Math.random() * 90 - 45) + 'deg');
          layer.append(item);
        }
        host.append(layer);
        const measure = () => {
          const distance = host.offsetHeight + 100;
          host.style.setProperty('--season-distance', distance + 'px');
          Array.from(layer.children).forEach((item, index) => {
            const duration = Math.max(9, distance / (60 + index * 7));
            item.style.setProperty('--particle-duration', duration + 's');
            item.style.setProperty('--particle-delay', (-duration * ((index + .5) / layer.children.length)) + 's');
          });
        };
        measure();
        if ('ResizeObserver' in window) {
          const resize = new ResizeObserver(measure);
          resize.observe(host);
          host.soaSeasonResize = resize;
        }
        hosts.add(host);
        observer.observe(host);
      });
    });
    if (!hosts.size) { observer.disconnect(); return; }
    motion.addEventListener('change',update);
    document.addEventListener('visibilitychange',update);
    const unload = event => {
      hosts.forEach(host => {
        if (event.target.contains(host)) { observer.unobserve(host); host.soaSeasonResize?.disconnect(); hosts.delete(host); visible.delete(host); }
      });
      if (!hosts.size) {
        observer.disconnect();
        motion.removeEventListener('change',update);
        document.removeEventListener('visibilitychange',update);
        document.removeEventListener('shopify:section:unload',unload);
      }
    };
    document.addEventListener('shopify:section:unload',unload);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
  document.addEventListener('shopify:section:load', prepare);
})();

(() => {
  function initPaperPeel() {
    document.querySelectorAll('#product-template .main-splide').forEach(gallery => {
      if (gallery.querySelector('.soa-peel-handle')) return;
      const track = gallery.querySelector('.splide__track');
      if (!track) return;
      const handle = document.createElement('button');
      handle.type = 'button'; handle.className = 'soa-peel-handle';
      handle.setAttribute('aria-label', 'Tirer le coin pour découvrir la photo suivante');
      handle.innerHTML = '<span aria-hidden="true">Tirez<br>ici</span>';
      const hint = document.createElement('p'); hint.className = 'soa-peel-hint';
      hint.textContent = 'Saisissez le coin et tirez vers le haut à gauche';
      const status = document.createElement('span'); status.className = 'visually-hidden'; status.setAttribute('aria-live','polite');
      gallery.append(handle, hint, status);
      let state = null, busy = false, suppressClick = false;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const visibleImage = slide => [...slide.querySelectorAll('a>img, :scope>img')].find(img => img.offsetWidth && getComputedStyle(img).display !== 'none');
      function prepare() {
        const slides = [...track.querySelectorAll('.splide__slide:not(.splide__slide--clone)')];
        const active = slides.findIndex(slide => slide.classList.contains('is-active'));
        if (active < 0) return null;
        const current = visibleImage(slides[active]);
        if (!current) return null;
        for (let i=1;i<slides.length;i++) {
          const slide = slides[(active+i)%slides.length];
          const next = visibleImage(slide);
          const thumb = gallery.closest('.product-gallery').querySelector('[aria-controls="'+slide.id+'"]');
          if (next && thumb) return {current, next, thumb};
        }
        return null;
      }
      function cleanup() {
        if (state?.layer) state.layer.remove();
        gallery.classList.remove('soa-peel-dragging');
        handle.style.removeProperty('transform');
        state = null; busy = false;
      }
      function commit() {
        if (!state || busy) return;
        busy = true;
        const target = state.thumb;
        state.layer.classList.add('soa-peel-complete');
        setTimeout(() => {
          target.click(); status.textContent = 'Photo suivante affichée.';
          hint.textContent = 'Une nouvelle vue. Tirez encore pour continuer.';
          setTimeout(cleanup, reduced.matches ? 0 : 180);
        }, reduced.matches ? 0 : 260);
      }
      function begin(x,y) {
        const media = prepare(); if (!media) return false;
        const layer = document.createElement('div'); layer.className = 'soa-peel-layer'; layer.setAttribute('aria-hidden','true');
        const under = document.createElement('img'); under.src = media.next.currentSrc || media.next.src; under.alt = '';
        const top = document.createElement('img'); top.src = media.current.currentSrc || media.current.src; top.alt = ''; top.className='soa-peel-top';
        const fold = document.createElement('span'); fold.className='soa-peel-fold';
        layer.append(under,top,fold); track.append(layer);
        state = {...media,layer,top,fold,x,y,progress:0}; gallery.classList.add('soa-peel-dragging'); return true;
      }
      handle.addEventListener('pointerdown',event => {
        if (busy || event.button > 0 || !begin(event.clientX,event.clientY)) return;
        event.preventDefault(); event.stopPropagation(); suppressClick = false;
        handle.setPointerCapture(event.pointerId);
      });
      handle.addEventListener('pointermove',event => {
        if (!state || busy) return;
        const distance = Math.max(0,Math.max(state.x-event.clientX,state.y-event.clientY));
        state.progress = Math.min(1,distance/Math.min(150,track.clientWidth*.34));
        if (distance>5) suppressClick = true;
        const cut = 12+state.progress*82;
        state.top.style.clipPath = 'polygon(0 0,100% 0,100% '+(100-cut)+'%,'+(100-cut)+'% 100%,0 100%)';
        state.fold.style.width = cut+'%'; state.fold.style.height = cut+'%';
        handle.style.transform = 'translate('+(-state.progress*50)+'px,'+(-state.progress*50)+'px)';
      });
      handle.addEventListener('pointerup',event => {
        if (!state || busy) return;
        if(handle.hasPointerCapture(event.pointerId)) handle.releasePointerCapture(event.pointerId);
        if (state.progress>.6) commit(); else cleanup();
      });
      handle.addEventListener('pointercancel',cleanup);
      handle.addEventListener('click',event => {
        event.preventDefault(); event.stopPropagation();
        if(suppressClick){suppressClick=false;return;}
        if(!busy && !state && begin(0,0)) commit();
      });
      gallery.addEventListener('keydown',event => {if(event.key==='Escape')cleanup();});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initPaperPeel,{once:true});else initPaperPeel();
  document.addEventListener('shopify:section:load',initPaperPeel);
})();
